import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { PublicCertificate } from './../../models/public-certificate.model';

import moment from 'moment';

const ENDPOINT = 'certificate';

@Injectable()
export class PublicCertificatesService {
  constructor(private http: HttpClient) {}

  getDetail(certificateId: string): Observable<PublicCertificate> {
    return this.http
      .get<PublicCertificate>(`${ENDPOINT}/public/${certificateId}`)
      .pipe(tap(formattedDetailDate));
  }

  downloadFile(certificateId: string): Observable<any> {
    return this.http.get<any>(`${ENDPOINT}/file/${certificateId}`, {
      params: { download: 'true' },
      responseType: 'text' as 'json'
    });
  }
}

function formattedDetailDate(
  certificate: PublicCertificate
): PublicCertificate {
  if (certificate) {
    certificate.timestamp = moment(certificate.timestamp).format(
      'DD/MM/YYYY HH:mm'
    );
  }

  return certificate;
}
